
  import {Component, Vue} from "vue-property-decorator";
  import FilterDashboard from "@/modules/Dashboard/components/FilterDashboard.vue";
  import HeaderDashboard from "@/modules/Dashboard/components/HeaderDashboard.vue";
  import MonthsDashboard from "@/modules/Dashboard/components/MonthsDashboard.vue";
  import {IDashboard} from "@/modules/Dashboard/interfaces/dashboard.interface";
  import OccupancyDashboard from "@/modules/Dashboard/components/OccupancyDashboard.vue";
  import {IApp} from "@/interfaces/app.interface";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

  @Component({
    components: {
      FilterDashboard,
      HeaderDashboard,
      MonthsDashboard,
      OccupancyDashboard,
    }
  })
  export default class IntroDashboard extends Vue {

    $refs: any;
    loadingDashboards = false;
    chartType = IDashboard.MonthChartType;
    themeName = IApp.ThemeName.Light;
    chartData = {
      [IDashboard.MonthChartType.Sum]: 'sumByYears',
      [IDashboard.MonthChartType.Count]: 'countByYears',
    };

    get dashboards() { return this.$store.state.dashboard.dashboards; }
    get loadingChart() { return this.$store.state.dashboard.waitingRequest || this.loadingDashboards; }

    created() {
      let cookieTheme = Vue.cookie.get(IApp.GlobalCookie.AppThemeName);
      if (cookieTheme && cookieBannerHelper.cookieConfig.optional) this.themeName = cookieTheme as IApp.ThemeName;
    }

    dashboardData(chartType): IDashboard.IByYearData[] {
      return this.dashboards[this.chartData[chartType]];
    }

    displayChart(chartType) {
      return this.dashboards && this.dashboardData(chartType).some(item => item[chartType] > 0);
    }

    async reloadDashboards() {
      this.loadingDashboards = true;
      await this.$nextTick();
      let refsDashboard = ['headerDashboard', 'monthsDashboardSum', 'monthsDashboardCount', 'occupancyDashboard',];
      refsDashboard.forEach(chart => {
        if (this.$refs[chart]) this.$refs[chart].updateChart();
      });

      setTimeout(() => this.loadingDashboards = false, 500);
    }
  }
